import { useCallback } from 'react'
import { useBucket } from '@mc/experiments-react'
import { usePromotion } from '@mc/promo-utils'
import { trackExperimentViewed } from '@mc/track-event'
import { PLAN_Z_FREE_GIFT_FLAG_NAME } from '../constants'

// Reads the Plan Z bucket directly (rather than importing @mc/checkout's hook)
// to avoid a circular package dependency — @mc/checkout already imports @mc/promos.
// The free-gift copy only applies to variant_1 during an active promotion, never for gifts.
export const useExperiment = ({
  isGift = false,
}: { isGift?: boolean } = {}) => {
  const { isPromotionOn } = usePromotion({ isGift })
  const bucket = useBucket(PLAN_Z_FREE_GIFT_FLAG_NAME)

  const isEligible = !isGift && isPromotionOn

  const trackEV = useCallback(() => {
    if (isEligible) {
      trackExperimentViewed(PLAN_Z_FREE_GIFT_FLAG_NAME)
    }
  }, [isEligible])

  return {
    // Eligible = in the experiment population (active promotion, non-gift),
    // used to fire `Experiment Viewed` for both control and variant arms.
    isEligible,
    isVariant: !!(isEligible && bucket?.startsWith('variant')),
    trackEV,
  }
}
